import React, { Fragment, useEffect, useState } from 'react'
import Img1 from "../images/profit.png"
import Img2 from "../images/business.png"
import Img3 from "../images/checkout-home.png"
import { formatNumberShort } from '../../utils/formatNumberShort';


const GrossNetProfit = ({ currentPeriod, previousPeriod, dateFrom, user }) => {


    const [chartType, setchartType] = useState("GROSS")
    const [chartUser, setChartUser] = useState("ADMIN")
    const metricCardBase = "p-6 rounded-2xl border cursor-pointer transition-all flex justify-between items-start";

    function getPercentageChange(current, previous) {
        if (!previous) return 0; // Avoid division by zero
        const change = ((current - previous) / previous) * 100;
        return change; // Positive if increase, negative if decrease
    }



    useEffect(() => {

        if (user?.role === "PM") {

            setChartUser("PM")
        }

    }, [user])



    return (
        <Fragment>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                {/* Card 1: Pending Earnings */}
                <div className={`${metricCardBase} ${chartType === "GROSS" ? "bg-gradient-to-br from-rose-50/50 to-white dark:from-transparent dark:to-transparent dark:bg-slate-950/70 border-rose-200 dark:border-rose-400/25 shadow-md dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)]" : "bg-white dark:bg-slate-950/70 border-zinc-200/80 dark:border-slate-800 shadow-sm hover:shadow-md"}`}
                    onClick={() => setchartType("GROSS")}
                >
                    <div>
                        <span className="text-xs font-bold text-zinc-500 dark:text-slate-400 tracking-wider uppercase">
                            {user?.role === "PMM" ? "Pending Payout" : "Pending Earnings"}
                        </span>
                        <br />
                        <span className="text-2xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1 inline-block">Rs.
                            {chartUser === "ADMIN" ?
                                formatNumberShort(currentPeriod?.grossAdminCommission || 0)
                                :
                                formatNumberShort(currentPeriod?.grossPmCommission || 0)
                            }
                        </span>
                        <br />
                        {chartUser === "ADMIN" ?
                            <span className={`text-sm font-[700] inline-block mt-1 ${getPercentageChange(currentPeriod?.grossAdminCommission, previousPeriod?.grossAdminCommission) > -0.1 ? "text-emerald-600" : "text-rose-600"}`}>
                                {getPercentageChange(currentPeriod?.grossAdminCommission, previousPeriod?.grossAdminCommission).toFixed(2)}%
                            </span>
                            :
                            <span className={`text-sm font-[700] inline-block mt-1 ${getPercentageChange(currentPeriod?.grossPmCommission, previousPeriod?.grossPmCommission) > -0.1 ? "text-emerald-600" : "text-rose-600"}`}>
                                {getPercentageChange(currentPeriod?.grossPmCommission, previousPeriod?.grossPmCommission).toFixed(2)}%
                            </span>
                        }
                    </div>
                    <div className="w-12 h-12 flex items-center justify-center dark:rounded-2xl dark:bg-rose-500/10 dark:p-2 dark:ring-1 dark:ring-rose-400/20">
                        <img src={Img1} alt="" className="w-full h-full object-contain" />
                    </div>
                </div>

                {/* Card 2: Completed Earnings */}
                <div className={`${metricCardBase} ${chartType === "NET" ? "bg-gradient-to-br from-purple-50/50 to-white dark:from-transparent dark:to-transparent dark:bg-slate-950/70 border-purple-200 dark:border-purple-400/25 shadow-md dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)]" : "bg-white dark:bg-slate-950/70 border-zinc-200/80 dark:border-slate-800 shadow-sm hover:shadow-md"}`}
                    onClick={() => setchartType("NET")}
                >
                    <div>
                        <span className="text-xs font-bold text-zinc-500 dark:text-slate-400 tracking-wider uppercase">
                            {user?.role === "PMM" ? "Paid Payout" : "Completed Earnings"}
                        </span>
                        <br />
                        <span className="text-2xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1 inline-block">Rs.
                            {chartUser === "ADMIN" ?
                                formatNumberShort(currentPeriod?.netAdminCommission || 0)
                                :
                                formatNumberShort(currentPeriod?.netPmCommission || 0)
                            }
                        </span>
                        <br />
                        {chartUser === "ADMIN" ?
                            <span className={`text-sm font-[700] inline-block mt-1 ${getPercentageChange(currentPeriod?.netAdminCommission, previousPeriod?.netAdminCommission) > -0.1 ? "text-emerald-600" : "text-rose-600"}`}>
                                {getPercentageChange(currentPeriod?.netAdminCommission, previousPeriod?.netAdminCommission).toFixed(2)}%
                            </span>
                            :
                            <span className={`text-sm font-[700] inline-block mt-1 ${getPercentageChange(currentPeriod?.netPmCommission, previousPeriod?.netPmCommission) > -0.1 ? "text-emerald-600" : "text-rose-600"}`}>
                                {getPercentageChange(currentPeriod?.netPmCommission, previousPeriod?.netPmCommission).toFixed(2)}%
                            </span>
                        }
                    </div>
                    <div className="w-12 h-12 flex items-center justify-center dark:rounded-2xl dark:bg-purple-500/10 dark:p-2 dark:ring-1 dark:ring-purple-400/20">
                        <img src={Img2} alt="" className="w-full h-full object-contain" />
                    </div>
                </div>

                {/* Card 3: Orders Count */}
                {user?.role !== "PM" && (
                    <div className={`${metricCardBase} ${chartType === "ORDERS" ? "bg-gradient-to-br from-sky-50/50 to-white dark:from-transparent dark:to-transparent dark:bg-slate-950/70 border-sky-200 dark:border-sky-400/25 shadow-md dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)]" : "bg-white dark:bg-slate-950/70 border-zinc-200/80 dark:border-slate-800 shadow-sm hover:shadow-md"}`}
                        onClick={() => setchartType("ORDERS")}
                    >
                        <div>
                            <span className="text-xs font-bold text-zinc-500 dark:text-slate-400 tracking-wider uppercase">Orders Count</span>
                            <br />
                            <span className="text-2xl font-[900] text-zinc-900 dark:text-white tracking-tight mt-1 inline-block">
                                {currentPeriod?.grossOrders?.length + currentPeriod?.netOrders?.length}
                            </span>
                            <br />
                            <span className={`text-sm font-[700] inline-block mt-1 ${(currentPeriod?.grossOrders?.length + currentPeriod?.netOrders?.length) - (previousPeriod?.grossOrders?.length + previousPeriod?.netOrders?.length) > 0 ? "text-emerald-600" : "text-rose-600"}`}>
                                <i className={`fa-solid ${(currentPeriod?.grossOrders?.length + currentPeriod?.netOrders?.length) - (previousPeriod?.grossOrders?.length + previousPeriod?.netOrders?.length) > 0 ? "fa-arrow-up" : "fa-arrow-down"}`}></i>
                                &nbsp;
                                {Math.abs((currentPeriod?.grossOrders?.length + currentPeriod?.netOrders?.length) - (previousPeriod?.grossOrders?.length + previousPeriod?.netOrders?.length))}
                            </span>
                        </div>
                        <div className="w-12 h-12 flex items-center justify-center dark:rounded-2xl dark:bg-sky-500/10 dark:p-2 dark:ring-1 dark:ring-sky-400/20">
                            <img src={Img3} alt="" className="w-full h-full object-contain" />
                        </div>
                    </div>
                )}
            </div>

            <div className="mt-4 flex justify-end">
                {
                    user?.role !== "PM" &&
                    <button className="w-full sm:w-auto text-sm lg:text-[1vmax] bg-[image:var(--gradient-2)] px-4 py-2 font-[600] text-white rounded-lg"
                        onClick={() => setChartUser(prev => prev === "ADMIN" ? "PM" : "ADMIN")}
                    >
                        {chartUser === "ADMIN" ? "Switch to PM" : "Switch to Admin"}
                        &nbsp;&nbsp;
                        <i className="fa-solid fa-arrow-right-long"></i>
                    </button>
                }
            </div>

        </Fragment>
    )
}

export default GrossNetProfit
